export default __webpack_public_path__ + "static/HIPAA-50ab02f519ec6672cc780e9cc9e7528c.png";